import { GDFPalletCode } from '../gdf/type';
import { Palette } from './palettes';

export const radar: Palette[] = [
    {
        name: 'Radar',
        id: GDFPalletCode.nexrad16,
        type: 'discreteBar',
        units: 'dBZ',
        // prettier-ignore
        values: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75],
        // prettier-ignore
        colors: ["#000000", "#7bb06a", "#6b9f5b", "#5a8e4b", "#4a7d3c", "#3a6d2d", "#295c1d", "#194b0e", "#d7d700", "#f5a60f", "#e19d5f", "#b24d00", "#ce2019", "#b01812", "#92101c", "#ff20df"]
    },
    {
        name: 'Radar (rain/snow/mix)',
        id: GDFPalletCode.nexrad48,
        type: 'combined',
        displayType: 'discreteBar',
        // prettier-ignore
        values: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75],
        units: 'dBZ',
        // prettier-ignore
        colors: ["#00000000", "#7bb06a", "#6b9f5b", "#5a8e4b", "#4a7d3c", "#3a6d2d", "#295c1d", "#194b0e", "#d7d700", "#f5a60f", "#e19d5f", "#b24d00", "#ce2019", "#b01812", "#92101c", "#ff20df", "#00000000", "#ffdcdc", "#ffcccc", "#ffbcbc", "#ffacac", "#ff9c9c", "#ff8c8c", "#ff7c7c", "#ff6c6c", "#ff6060", "#ff5050", "#ff4040", "#ff3030", "#ff2020", "#ff1010", "#ff0000", "#00000000", "#00efff", "#00d4ff", "#00bfff", "#00adff", "#0094ff", "#007bff", "#0068ff", "#0055ff", "#0443f5", "#0026ff", "#000eff", "#0000ff", "#0000df", "#0000cb", "#000089"],
        palettes: [
            { name: 'Rn', offset: 0, length: 16 },
            { name: 'Mx', offset: 16, length: 16 },
            { name: 'Sn', offset: 32, length: 16 }
        ]
    },
    {
        name: 'Precipitation',
        id: GDFPalletCode.precip,
        type: 'discreteBar',
        units: 'inches',
        // prettier-ignore
        values: [0, 0.1, 0.25, 0.5, 0.75, 1, 1.5, 2, 3, 4, 5, 6, 8, 10, 12, 15],
        // prettier-ignore
        colors: ["#000000", "#8bc1c9", "#6b90ca", "#00adff", "#007bff", "#000eff", "#00dc00", "#5a8e4b", "#194b0e", "#d7d700", "#f5a60f", "#e19d5f", "#b24d00", "#ce2019", "#92101c", "#ff20df", "#ff0000"]
    },
    {
        name: 'Echo tops',
        id: GDFPalletCode.echotops,
        type: 'discreteBar',
        units: 'ft',
        // prettier-ignore
        values: [0, 5000, 10000, 15000, 20000, 25000, 30000, 35000, 40000, 45000, 50000, 55000, 60000, 65000, 70000],
        // prettier-ignore
        colors: ["#000000", "#40efef", "#2aa0ca", "#1550a5", "#000080", "#60bf31", "#107010", "#e0df20", "#dfb010", "#ff8010", "#cf5000", "#ff0000", "#7f0000", "#ff00ff", "#7f007f", "#febffe"]
    },
    {
        name: 'Radar 64',
        id: GDFPalletCode.nexrad64,
        type: 'discreteBar',
        units: 'dBZ',
        // prettier-ignore
        values: [],
        // prettier-ignore
        colors: ["#000000", "#7bb06a", "#6b9f5b", "#5a8e4b", "#4a7d3c", "#3a6d2d", "#295c1d", "#194b0e", "#d7d700", "#f5a60f", "#e19d5f", "#b24d00", "#ce2019", "#b01812", "#92101c", "#ff20df", "#000000", "#ffdcdc", "#ffcccc", "#ffbcbc", "#ffacac", "#ff9c9c", "#ff8c8c", "#ff7c7c", "#ff6c6c", "#ff6060", "#ff5050", "#ff4040", "#ff3030", "#ff2020", "#ff1010", "#ff0000", "#000000", "#ffc8ff", "#fbb6fb", "#f7a4f7", "#f492f4", "#f080f0", "#ed6eed", "#e95ce9", "#e64be6", "#d740d7", "#c935c9", "#bb2abb", "#ac20ac", "#9e159e", "#900a90", "#820082", "#000000", "#00efff", "#00d4ff", "#00bfff", "#00adff", "#0094ff", "#007bff", "#0068ff", "#0055ff", "#0443f5", "#0026ff", "#000eff", "#0000ff", "#0000df", "#0000cb", "#000089"]
    },
    {
        name: 'Radar Canada',
        type: 'discreteBar',
        // prettier-ignore
        colors: ["#000000", "#00fc74", "#00af26", "#008800", "#fcfc00", "#888800", "#fc8800", "#af1300", "#610000"],
        id: GDFPalletCode.radarcan,
        units: 'dBZ',
        // prettier-ignore
        values: [5, 23, 33, 40, 45, 50, 55, 59]
    },
    {
        name: 'Radar coverage',
        type: 'discreteBar',
        // prettier-ignore
        colors: ["#000000", "#747474"],
        id: GDFPalletCode.radarcov,
        // prettier-ignore
        values: [],
        noTooltip: true
    },
    {
        id: GDFPalletCode.echotops70,
        name: 'Echo tops',
        type: 'gradientBar',
        units: 'ft',
        minValue: -1000,
        maxValue: 255000,
        maxDisplayValue: 70000,
        minDisplayValue: 10000,
        getValue: (v) => v * 1000 - 1000,
        // 72 values
        stops: [
            { color: '#c3c3c3', value: -1000, hideLabel: true },
            { color: '#646464', value: 0, hideLabel: true },
            { color: '#747d82', value: 1000 },
            { color: '#8496a0', value: 2000, hideLabel: true },
            { color: '#94afbe', value: 3000, hideLabel: true },
            { color: '#a4c8dc', value: 4000, hideLabel: true },
            { color: '#b4e1fa', value: 5000, hideLabel: true },
            { color: '#a8d5fa', value: 6000, hideLabel: true },
            { color: '#9ccafa', value: 7000, hideLabel: true },
            { color: '#90bff9', value: 8000, hideLabel: true },
            { color: '#85b4fa', value: 9000, hideLabel: true },
            { color: '#79a9fa', value: 10000 },
            { color: '#6d9efa', value: 11000, hideLabel: true },
            { color: '#6293fa', value: 12000, hideLabel: true },
            { color: '#5688fa', value: 13000, hideLabel: true },
            { color: '#4b7dfa', value: 14000, hideLabel: true },
            { color: '#4664fa', value: 15000, hideLabel: true },
            { color: '#405ee9', value: 16000, hideLabel: true },
            { color: '#3a58d8', value: 17000, hideLabel: true },
            { color: '#3553c7', value: 18000, hideLabel: true },
            { color: '#2f4db7', value: 19000, hideLabel: true },
            { color: '#2a48a6', value: 20000 },
            { color: '#244295', value: 21000, hideLabel: true },
            { color: '#1f3d85', value: 22000, hideLabel: true },
            { color: '#193774', value: 23000, hideLabel: true },
            { color: '#143264', value: 24000, hideLabel: true },
            { color: '#0a1464', value: 25000, hideLabel: true },
            { color: '#0e2869', value: 26000, hideLabel: true },
            { color: '#123c6f', value: 27000, hideLabel: true },
            { color: '#175074', value: 28000, hideLabel: true },
            { color: '#1b647a', value: 29000, hideLabel: true },
            { color: '#20787f', value: 30000 },
            { color: '#248c85', value: 31000, hideLabel: true },
            { color: '#29a08a', value: 32000, hideLabel: true },
            { color: '#2db490', value: 33000, hideLabel: true },
            { color: '#32c896', value: 34000, hideLabel: true },
            { color: '#32c864', value: 35000, hideLabel: true },
            { color: '#2cba58', value: 36000, hideLabel: true },
            { color: '#26ac4d', value: 37000, hideLabel: true },
            { color: '#219e42', value: 38000, hideLabel: true },
            { color: '#1b9037', value: 39000, hideLabel: true },
            { color: '#16822c', value: 40000 },
            { color: '#107421', value: 41000, hideLabel: true },
            { color: '#0b6616', value: 42000, hideLabel: true },
            { color: '#05580b', value: 43000, hideLabel: true },
            { color: '#004b00', value: 44000, hideLabel: true },
            { color: '#fafa02', value: 45000 },
            { color: '#ecec01', value: 46000, hideLabel: true },
            { color: '#dede01', value: 47000, hideLabel: true },
            { color: '#d0d001', value: 48000, hideLabel: true },
            { color: '#c2c201', value: 49000, hideLabel: true },
            { color: '#b4b401', value: 50000 },
            { color: '#a6a601', value: 51000, hideLabel: true },
            { color: '#989801', value: 52000, hideLabel: true },
            { color: '#8a8a01', value: 53000, hideLabel: true },
            { color: '#7d7d01', value: 54000, hideLabel: true },
            { color: '#fa9696', value: 55000 },
            { color: '#f18d8d', value: 56000, hideLabel: true },
            { color: '#e98585', value: 57000, hideLabel: true },
            { color: '#e07c7c', value: 58000, hideLabel: true },
            { color: '#d87474', value: 59000, hideLabel: true },
            { color: '#d06c6c', value: 60000 },
            { color: '#c76363', value: 61000, hideLabel: true },
            { color: '#bf5b5b', value: 62000, hideLabel: true },
            { color: '#b75353', value: 63000, hideLabel: true },
            { color: '#af4b4b', value: 64000, hideLabel: true },
            { color: '#a64242', value: 65000, hideLabel: true },
            { color: '#9e3a3a', value: 66000, hideLabel: true },
            { color: '#953131', value: 67000, hideLabel: true },
            { color: '#8d2929', value: 68000, hideLabel: true },
            { color: '#852121', value: 69000, hideLabel: true },
            { color: '#7d1919', value: 70000 }
        ]
    },
    {
        id: GDFPalletCode.radsum,
        name: 'Radsum',
        type: 'discreteBar',
        values: [null],
        colors: ['#000', '#000', '#000', '#000', '#000', '#000'],
        noTooltip: true,
        hideFromLegend: true
    }
];
